export default __webpack_public_path__ + "static/media/icon_human.f3a93238.svg";